<template>
  <div class="infos-register">
    <form-default
      :contentTitle="$t('views.InfosRegister.contentTitle')"
      :titleLogin="$t('views.InfosRegister.titleLogin')"
      :inputs="inputs"
      :button="button"
    ></form-default>
  </div>
</template>
<script>
import FormDefault from "../../components/Forms/FormDefault";
import api from "../../api/authentication.js";
import Bus from "@/main.js";
export default {
  components: {
    FormDefault
  },
  data() {
    return {
      inputs: [
        {
          placeholder: this.$t("views.InfosRegister.inputsPlaceholder[0]"),
          type: "text",
          name: "nome"
        },
        {
          placeholder: this.$t("views.InfosRegister.inputsPlaceholder[1]"),
          type: "text",
          name: "cpf"
        }
      ],
      button: {
        name: this.$t("views.InfosRegister.button"),
        typeLogin: "email",
        action: "finish-register"
      }
    };
  },
  created() {
    Bus.$on("finish-register", this.register);
  },
  destroyed() {
    Bus.$off("finish-register");
  },
  methods: {
    async register() {
      const nomeSend = nome.value;
      const cpfSend = cpf.value;
      const response = await api.post("/users", {
        name: nomeSend,
        cpf: cpfSend
      });
      // console.log(response);
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
